import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError, receiveSuccess } from '../../store/actions/notificationAction';

import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import GhaModel from '../../models/Gha';

import ghaRemote from '../../api/ghaRemote';

import DockOverloadModal from './DockOverloadModal';

import MomentUtils from "@date-io/moment";
import moment, { Moment } from 'moment';

import { dayMap } from '../../utils/dayMap';

type Type = 'import' | 'export';

interface DockerOverloadModalProps { 
  openDockOverloadModal: boolean;
  handleCloseDockOverloadModal: (time: string) => void;
  forInfo: boolean;
  ghaID: number;
  type: Type;
  receiveError: Function;
  date: string;
  time: string;
  secretKey ?: string;
};

interface DockerOverloadModalState { 
  selectTime: string;
  selectedValue: number;
  selectedDate: Moment | string;
  docsLoad: Array<Array<number>>;
  workingHours: Array<{end: string, start: string }>;
  dock: Array<number>;
  work: Array<{ end: string, start: string }>;
  cams: Array<{ url: string, description: string } | null>;
  avgWaitTime: {hours: number | null, minutes: number | null};
};

class DockerOverloadModalContainer extends Component <DockerOverloadModalProps, DockerOverloadModalState> {
  state = {
    selectTime: '',
    selectedValue: -1,
    selectedDate:  new MomentUtils().date(),
    docsLoad: [],
    workingHours: [],
    dock: [],
    work: [],
    cams: [],
    avgWaitTime: {hours: null, minutes: null}
  };

  intervalGhaFetch: number = -1;

  componentDidMount(){

    // Update gha info every minute
    this.intervalGhaFetch = window.setInterval(this.load, 60000);
    this.load();
  };

  componentDidUpdate(prevProps: DockerOverloadModalProps) {
    if(prevProps !== this.props && this.props.ghaID !== -1) {
      this.clearGhaFetchInterval();

      // Update gha info every minute
      this.intervalGhaFetch = window.setInterval(this.load, 60000);
      this.load();
    } 
  }

  load = (): void => {

    const id = this.props.ghaID;
    const selectedDate : Moment  = this.props.date ? moment(this.props.date) : new MomentUtils().date();
    const selectTime: string = this.props.time ? `${this.props.time.slice(0,2)}.${this.props.time.slice(2,4)}` : ''
    const selectedValue: number = this.props.time ? Math.floor(+selectTime) : -1;
    this.setState({ selectedDate, selectTime , selectedValue});
    const secretKey: string = this.props.secretKey? this.props.secretKey : '';
 
    ghaRemote.getGhaInfo(id, secretKey).then((resp: ApiResponse<GhaModel>) => {

      const gha: GhaModel | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;
      

      if (gha) {

        const workingHours: Array<{ end: string, start: string }> = this.props.type === 'import' ? gha.working_hours['import'] : gha.working_hours['export'];
        const docsLoad: Array<Array<number>> = gha.dock_load;

        const day = this.state.selectedDate.format('ddd');
        const dayWeek: number = dayMap[`${day}`]
       
        const dock: Array<number> = docsLoad[dayWeek];
       
        const work: any = workingHours[dayWeek];
        const cams: Array<{url:string, description: string} | null> = gha.info.cams ? gha.info.cams : []; 
        this.setState ({workingHours, docsLoad, dock, work, cams, avgWaitTime: gha.avg_wait_time});
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  };

  handleChangeSelectedValue = (event: any): void  => {

    const selectedValue: number = +event.target.value;
    let selectTime: string = selectedValue.toFixed(2).toString();
    
    if (selectTime.length === 4 ) {
      selectTime = '0'+ selectTime;
    };
   
    this.setState({ 
      selectTime,
      selectedValue 
    });
  };

  handleChangeDate = (date: Moment): void => {

    const day = date.format('ddd');
    const dayWeek: number = dayMap[`${day}`]

    const dock: Array<number> = this.state.docsLoad[dayWeek];
    const work: any = this.state.workingHours[dayWeek];

    this.setState({ selectedDate: date, dock, work });
  };

  handleChangeSelectTime = (event: any): void => {

    const selectTime: string = event.target.value;
    const selectedValue: number = Math.floor(+selectTime);

    this.setState({
      selectedValue,
      selectTime 
    });
  };

  componentWillUnmount(){
    this.clearGhaFetchInterval();
  };

  clearGhaFetchInterval() {
    if(this.intervalGhaFetch !== -1) {
      clearInterval(this.intervalGhaFetch);
      this.intervalGhaFetch = -1;
    }
  }

  getGhaWaitTimeAsString() {
    const {hours, minutes} = this.state.avgWaitTime;
    if(hours === null || minutes === null)
      return "--:--";
    
      let hoursString = new String(this.state.avgWaitTime.hours);
      hoursString = hoursString.length === 1? '0' + hoursString: hoursString;
      let minutesString = new String(this.state.avgWaitTime.minutes);
      minutesString = minutesString.length === 1? '0' + minutesString: minutesString;
      return `${hoursString}:${minutesString}`;
  }

  render() {

    return (
      <DockOverloadModal
        modalOpen={ this.props.openDockOverloadModal }
        handleClose={ this.props.handleCloseDockOverloadModal }
        handleChange={ this.handleChangeSelectTime }
        selectTime={ this.state.selectTime }
        waitingTime={ this.getGhaWaitTimeAsString() }
        selectedValue={ this.state.selectedValue }
        handleChangeSelectedValue={ this.handleChangeSelectedValue }
        forInfo={ this.props.forInfo }
        selectedDate={ this.state.selectedDate }
        handleChangeDate={ this.handleChangeDate }
        dockLoad={ this.state.dock }
        workingHours={ this.state.work }
        cams={ this.state.cams }
        ghaId={ this.props.ghaID }
      />
    )
  };
};


const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess:(message: string) => dispatch(receiveSuccess(message))
  };
};

export default connect(null, mapDispatchToProps)(DockerOverloadModalContainer);